import "whatwg-fetch"; // window.fetch polyfill

import "normalize.css/normalize.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "./src/styles/global.css";
import { FocusStyleManager } from "@blueprintjs/core";

FocusStyleManager.onlyShowFocusOnTabs();
